import { FONT_WEIGHT } from '@bugbug/core/theme/fonts';
import styled from 'styled-components';

export const Description = styled.section`
  font-weight: ${FONT_WEIGHT.NORMAL};
  line-height: 17px;
  margin: 5px 0 0 0;
`;
